import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { IlinkedStandard } from "../../../model/interface/linkedStandard";
import LinkedStandardDetail from "../../shared/common/linkedStandardDetail";
import Constant from "../../../utils/constant";
import { AddStandardIcon } from "../../../assets/icons/index";

interface LinkedStandardProps {
  standardId: number;
  standardData: any;
}

function LinkedStandard(props: LinkedStandardProps) {
  const { standardId, standardData } = props;
  const [linkedStandards, setLinkedStandards] = useState<IlinkedStandard[]>([]);
  const navigate = useNavigate();

  async function bindLinkedStandard() {
    const service = await import("../../../api/standardLinking.service");
    service.getLinkedStandards(standardId).then((response) => {
      setLinkedStandards(response.data);
    });
  }

  useEffect(() => {
    bindLinkedStandard();
  }, [props.standardId]);
  const handleRedirect = () => {
    navigate(Constant.STANDARDLINK, { state: { autoFillData: standardData } });
  };
  return (
    <Fragment>
      <div className="text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg">
        <div className="flex w-full justify-between items-center mt-1 mb-4 rounded-lg">
          <button
            onClick={() => handleRedirect()}
            type="button"
            className="flex items-center text-sm  cursor-pointer"
          >
            <AddStandardIcon />
            Link Standard
          </button>
        </div>

        {linkedStandards &&
          linkedStandards.some(
            (r) => r.linkingType === Constant.StandardLinkingType.ONEWAY
          ) && (
            <div>
              <div className="flex items-end justify-between mb-3">
                <h3 className="text-primary-color font-medium text-sm tracking-wide">
                  One Way Link
                </h3>
              </div>
              <div className="grid grid-cols-2 gap-4">
                {linkedStandards
                  .filter(
                    (r) => r.linkingType === Constant.StandardLinkingType.ONEWAY
                  )
                  .map((linkedStandard, index) => {
                    linkedStandard.sourceStandardId = standardId;
                    const linkedStandardProps = {
                      ...linkedStandard,
                      bindStandards: bindLinkedStandard,
                    };
                    return (
                      <Fragment key={index}>
                        <LinkedStandardDetail {...linkedStandardProps} />
                      </Fragment>
                    );
                  })}
              </div>
            </div>
          )}

        {linkedStandards &&
          linkedStandards.some(
            (r) => r.linkingType === Constant.StandardLinkingType.TWOWAY
          ) && (
            <div>
              <h3 className="text-primary-color mb-3 mt-4 font-medium text-sm tracking-wide">
                Two Way Link
              </h3>
              <div className="grid grid-cols-2 gap-x-4 gap-y-4">
                {linkedStandards
                  .filter(
                    (r) => r.linkingType === Constant.StandardLinkingType.TWOWAY
                  )
                  .map((linkedStandard, index) => {
                    linkedStandard.sourceStandardId = standardId;
                    const linkedStandardProps = {
                      ...linkedStandard,
                      bindStandards: bindLinkedStandard,
                    };
                    return (
                      <Fragment key={index}>
                        <LinkedStandardDetail {...linkedStandardProps} />
                      </Fragment>
                    );
                  })}
              </div>
            </div>
          )}
      </div>
    </Fragment>
  );
}

export default LinkedStandard;
